const GEOCODE_API_URL = 'https://maps.googleapis.com/maps/api/geocode/json';

/**
 * Geocode an address via the Google Geocoding REST API.
 * Avoids loading maps/api/js globally (fixes HTMLDialogElement errors on older Safari).
 */
export const geocodeByAddress = async (address) => {
  const apiKey = __CONFIG__.googleApiKey;
  const response = await fetch(
    `${GEOCODE_API_URL}?address=${encodeURIComponent(address)}&key=${apiKey}`,
  );
  const data = await response.json();

  if (data.status !== 'OK' || !data.results?.length) {
    throw new Error(data.status || 'Geocoding failed');
  }

  return data.results;
};

export default geocodeByAddress;
